import { o_util } from "../../common/namespaces";
import { assignNamespace } from "../../common/assignNamespace.js";
import { toggle } from "../../exports/toggle";
import { deprecated } from "../../common/logger";

import { ajaxLegacy } from "./ajax/ajax.legacy.js";
import { ajax } from "./ajax/index.js";
import { cookie } from "../../globals/cookie.js";

export interface LegacyUtils {
  legacy: {
    ajaxLegacy: typeof ajaxLegacy;
  };

  ajax: typeof ajax;
}

if (toggle.get("gr_legacy_ajax_enable", true)) {
  const oLegacy = o_util as unknown as LegacyUtils;

  assignNamespace(oLegacy, "legacy", {
    ajaxLegacy: deprecated(ajaxLegacy, "ajax", "ajaxLegacy", "use native fetch instead"),
  });

  oLegacy.ajax = ajax;
}

/**
 *
 *
 */
/*                                                                */
cookie.exists("app") && document.documentElement.classList.add("app");
